import { render, staticRenderFns } from "./TemplatedSections.vue?vue&type=template&id=7173450f&scoped=true"
import script from "./TemplatedSections.vue?vue&type=script&lang=js"
export * from "./TemplatedSections.vue?vue&type=script&lang=js"
import style0 from "./TemplatedSections.vue?vue&type=style&index=0&id=7173450f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7173450f",
  null
  
)

export default component.exports